import React from "react";

const WorkWithUs = () => {
	return (
		<div className="page-fit flex items-center justify-center">
			<div className="lg:w-[80%] flex md:flex-row flex-col items-center gap-4 sm:gap-8 justify-center sm:p-6 p-4">
				<div className="flex flex-col justify-center items-start h-full w-[70%] py-3 sm:ps-10">
					<h1 className="text-2xl sm:text-3xl font-semibold">
						We are hiring!
					</h1>
					<p className="text-md font-medium">
						We are looking for freelance Developers, Subtitle
						writers, Content writers and Video editors. If you think
						you are fit for the role. Submit the form. Make sure you
						have a valid email so we can contact you back in case
						your application gets selected. Cheers!
					</p>
				</div>
				<form className="flex flex-col justify-center items-start h-full w-[100%] sm:max-w-96 p-5 sm:p-8 bg-gray-200 shadow-xl mb-4 rounded-md">
					<p className="opacity-70">India Only</p>
					<h2 className="text-lg font-semibold mb-4">Apply Now!</h2>
					<div className="w-full mb-4">
						<p className="mb-2 text-base opacity-80">Full Name</p>
						<input
							className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-full"
							type="text"
							name="name"
						></input>
					</div>
					<div className="w-full mb-4">
						<p className="mb-2 text-base opacity-80">Email</p>
						<input
							className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-full"
							type="email"
							name="email"
						></input>
					</div>
					<div className="w-full mb-4">
						<p className="mb-2 text-base opacity-80">
							Phone Number
						</p>
						<input
							className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-full"
							type="number"
							name="phoneNumber"
						></input>
					</div>
					<div className="w-full mb-4">
						<p className="mb-2 text-base opacity-80">
							Link to your Resume
						</p>
						<input
							className="border border-gray-500 rounded-md px-3 py-2 outline-orange-600 w-full"
							type="url"
							name="resumeUrl"
						></input>
					</div>
					<div className="w-full mb-4">
						<p className="mb-2 text-base opacity-80">Skill:</p>
						<div className="flex flex-row flex-wrap justify-between gap-3">
							<div className="flex gap-2 items-center">
								<input
									className="cursor-pointer border border-gray-500 rounded-md h-5 w-5 outline-orange-600"
									type="radio"
									name="skill"
									value="subtitle-writer"
								></input>
								<label className="opacity-60 text-sm">
									Subtitle Writer
								</label>
							</div>
							<div className="flex gap-2 items-center">
								<label className="opacity-60 text-sm">
									Python Dev
								</label>
								<input
									className="cursor-pointer border border-gray-500 rounded-md h-5 w-5 outline-orange-600"
									type="radio"
									name="skill"
									value="python-dev"
								></input>
							</div>
							<div className="flex gap-2 items-center">
								<input
									className="cursor-pointer border border-gray-500 rounded-md h-5 w-5 outline-orange-600"
									type="radio"
									name="skill"
									value="content-writer"
								></input>
								<label className="opacity-60 text-sm">
									Content Writer
								</label>
							</div>
							<div className="flex gap-2 items-center">
								<label className="opacity-60 text-sm">
									PHP Dev
								</label>
								<input
									className="cursor-pointer border border-gray-500 rounded-md h-5 w-5 outline-orange-600"
									type="radio"
									name="skill"
									value="php-dev"
								></input>
							</div>
							<div className="flex gap-2 items-center">
								<input
									className="cursor-pointer border border-gray-500 rounded-md h-5 w-5 outline-orange-600"
									type="radio"
									name="skill"
									value="video-editor"
								></input>
								<label className="opacity-60 text-sm">
									Video Editor
								</label>
							</div>
							<div className="flex gap-2 items-center">
								<label className="opacity-60 text-sm">
									JavaScript Dev
								</label>
								<input
									className="cursor-pointer border border-gray-500 rounded-md h-5 w-5 outline-orange-600"
									type="radio"
									name="skill"
									value="javascript-dev"
								></input>
							</div>
							<div className="flex gap-2 items-center">
								<input
									className="cursor-pointer border border-gray-500 rounded-md h-5 w-5 outline-orange-600"
									type="radio"
									name="skill"
									value="mern-dev"
								></input>
								<label className="opacity-60 text-sm">
									MERN Dev
								</label>
							</div>
							<div className="flex gap-2 items-center">
								<label className="opacity-60 text-sm">
									Java Dev
								</label>
								<input
									className="cursor-pointer border border-gray-500 rounded-md h-5 w-5 outline-orange-600"
									type="radio"
									name="skill"
									value="java-dev"
								></input>
							</div>
						</div>
					</div>
					<button
						onClick={(e) => e.preventDefault()}
						className="text-lg text-white font-semibold rounded-md bg-orange-600 px-5 py-2 hover:bg-orange-800"
					>
						Submit
					</button>
					<p className="text-xs pt-4 opacity-70">
						We will be in touch soon!
					</p>
				</form>
			</div>
		</div>
	);
};

export default WorkWithUs;
